import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/envira': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 32c477.6 0 366.6 317.3 367.1 366.3l80.9 81.7h-26l-70.4-71.2c-39 4.2-124.4 34.5-214.4-37-90.2-71.5-85.2-157.1-137.2-339.8zM79.7 78c-49.7-23.5-5.2 9.2-5.2 9.2 45.2 31.2 66 73.7 90.2 119.9 31.5 60.2 79 139.7 144.2 167.7 65 28 34.2 12.5 6-8.5-28.2-21.2-68.2-87-91-130.2-31.7-60-61-118.6-144.2-158.1z'
      }
    ]
  }
})
